import React, { useState, useEffect, useCallback } from "react";
import instance, { apiEncryptRequest, decryptData } from "../../Api";
import { useAuth } from "../../AuthContext";

const CYCLE_LABEL = {
  monthly:     "Monthly",
  quarterly:   "Quarterly",
  half_yearly: "Half Yearly",
  annually:    "Annually",
};

const S = {
  page: {
    fontFamily: "'Inter', 'Nunito', sans-serif",
    padding: "73px 41px 43px 175px", 
    color: "#1A2332",
  },
  header: { display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 },
  title: { fontSize: 26, fontWeight: 800, color: "#1A2332", margin: 0 },
  sub: { fontSize: 14, color: "#7A90A8", marginTop: 4, fontWeight: 600 },
  backBtn: {
    display: "inline-flex", alignItems: "center", gap: 6,
    padding: "9px 16px", background: "#fff",
    border: "1px solid #D6E4F0", borderRadius: 8,
    fontSize: 13, fontWeight: 700, color: "#3D5068", cursor: "pointer",
    transition: "all .2s",
  },
  browseBtn: {
    padding: "10px 20px",
    background: "linear-gradient(135deg,#1A5FA8,#2D7DD2)",
    color: "#fff", border: "none", borderRadius: 10,
    fontSize: 14, fontWeight: 800, cursor: "pointer",
    boxShadow: "0 4px 14px rgba(45,125,210,0.25)",
  },
  // Stats
  stats: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
    gap: 14, marginBottom: 24,
  },
  stat: {
    background: "#fff", border: "1px solid #D6E4F0",
    borderRadius: 14, padding: "18px", textAlign: "center",
    boxShadow: "0 2px 8px rgba(45,125,210,0.06)",
  },
  statVal: { fontSize: 26, fontWeight: 800, color: "#1A2332" },
  statLabel: { fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: ".1em", color: "#7A90A8", marginTop: 5 },
  // Cards
  cards: { display: "flex", flexDirection: "column", gap: 14 },
  card: {
    background: "#fff", border: "1px solid #D6E4F0",
    borderRadius: 16, overflow: "hidden",
    boxShadow: "0 2px 8px rgba(45,125,210,0.06)",
  },
  cardBody: {
    display: "flex", alignItems: "center",
    justifyContent: "space-between",
    padding: "18px 22px", gap: 16, flexWrap: "wrap",
  },
  cardLeft: { display: "flex", alignItems: "center", gap: 14, flex: 1 },
  catIcon: {
    width: 46, height: 46, borderRadius: 12,
    background: "rgba(45,125,210,0.06)",
    border: "1px solid rgba(45,125,210,0.12)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: 22, flexShrink: 0,
  },
  svcName: { fontSize: 16, fontWeight: 800, color: "#1A2332" },
  svcCat: { fontSize: 12, color: "#7A90A8", fontWeight: 600, marginTop: 2 },
  cycleChip: {
    display: "inline-block", padding: "3px 9px",
    background: "rgba(45,125,210,0.08)", color: "#2D7DD2",
    border: "1px solid rgba(45,125,210,0.15)",
    borderRadius: 6, fontSize: 10, fontWeight: 800,
    textTransform: "uppercase", marginTop: 4,
  },
  cardRight: { display: "flex", alignItems: "center", gap: 18, flexShrink: 0, flexWrap: "wrap" },
  price: { textAlign: "right" },
  priceVal: { fontSize: 20, fontWeight: 800, color: "#2D7DD2" },
  priceOrig: { fontSize: 12, color: "#7A90A8", fontWeight: 600, textDecoration: "line-through" },
  savedChip: {
    fontSize: 11, fontWeight: 800, color: "#16A34A",
    background: "rgba(22,163,74,0.08)", border: "1px solid rgba(22,163,74,0.2)",
    borderRadius: 10, padding: "2px 8px", display: "inline-block", marginTop: 3,
  },
  // Status badge
  statusBadge: (status, isActive) => ({
    display: "inline-flex", alignItems: "center", gap: 5,
    padding: "5px 12px", borderRadius: 20,
    fontSize: 11, fontWeight: 800, textTransform: "uppercase",
    ...(isActive
      ? { background: "rgba(22,163,74,0.1)", color: "#16A34A", border: "1px solid rgba(22,163,74,0.25)" }
      : status === "expired"
      ? { background: "rgba(220,38,38,0.08)", color: "#DC2626", border: "1px solid rgba(220,38,38,0.2)" }
      : { background: "rgba(120,113,108,0.1)", color: "#57534e", border: "1px solid rgba(120,113,108,0.2)" }),
  }),
  statusDot: (isActive) => ({
    width: 6, height: 6, borderRadius: "50%",
    background: isActive ? "#16A34A" : "#DC2626",
    ...(isActive ? { animation: "blink 1.8s ease infinite" } : {}),
  }),
  // Detail bar
  detailBar: {
    background: "#F4F8FD", borderTop: "1px solid #D6E4F0",
    padding: "10px 22px",
    display: "flex", gap: 24, flexWrap: "wrap",
  },
  detailItem: { display: "flex", flexDirection: "column", gap: 2 },
  detailLabel: { fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: ".1em", color: "#7A90A8" },
  detailVal: { fontSize: 13, fontWeight: 700, color: "#3D5068" },
  // Empty
  empty: {
    background: "#fff", border: "1px solid #D6E4F0", borderRadius: 16,
    textAlign: "center", padding:"73px 41px 43px 175px;",
    boxShadow: "0 2px 8px rgba(45,125,210,0.06)",
  },
  emptyIcon: { fontSize: 56, marginBottom: 14 },
  emptyTitle: { fontSize: 18, fontWeight: 800, color: "#1A2332", marginBottom: 6 },
  emptyBtn: {
    display: "inline-flex", alignItems: "center", gap: 8,
    padding: "12px 24px", marginTop: 16,
    background: "linear-gradient(135deg,#1A5FA8,#2D7DD2)",
    color: "#fff", border: "none", borderRadius: 10,
    fontSize: 14, fontWeight: 800, cursor: "pointer",
    boxShadow: "0 4px 20px rgba(45,125,210,0.25)",
  },
  loading: { textAlign: "center", padding: "73px 41px 43px 175px", color: "#7A90A8", fontSize: 16, fontWeight: 700 },
};

const fmt = (n) => "₹" + parseFloat(n).toLocaleString("en-IN", { minimumFractionDigits: 2 });

const MyAddonsPage = ({ isMobile, navigate }) => {
  const { smuser } = useAuth();
  const [loading,   setLoading]   = useState(true);
  const [purchases, setPurchases] = useState([]);

  const fetchPurchases = useCallback(async () => {
    setLoading(true);
    try {
      const enc  = await apiEncryptRequest({ user_id: smuser?.id });
      const res  = await instance.post("/addon-services/my-purchases", enc);
      const data = decryptData(res.data);
      if (data?.success) setPurchases(data.purchases || []);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  }, [smuser?.id]);

  useEffect(() => { fetchPurchases(); }, [fetchPurchases]);

  const activeCount  = purchases.filter((p) => p.is_active).length;
  const totalSpent   = purchases.reduce((s, p) => s + parseFloat(p.final_price || 0), 0);
  const totalSaved   = purchases.reduce((s, p) => s + parseFloat(p.coupon_discount || 0), 0);

  if (loading) return <div style={S.loading}>⚡ Loading your purchases...</div>;

  return (
    <div style={S.page}>
      <style>{`@keyframes blink { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:.3;transform:scale(.6)} }`}</style>

      {/* Header */}
      <div style={S.header}>
        <div>
          <h1 style={S.title}>📋 My Add-on Purchases</h1>
          <p style={S.sub}>All your active and past add-on subscriptions</p>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button style={S.backBtn} onClick={() => navigate?.("/addon-services")}>← Browse Services</button>
        </div>
      </div>

      {/* Stats */}
      <div style={S.stats}>
        <div style={S.stat}>
          <div style={S.statVal}>{purchases.length}</div>
          <div style={S.statLabel}>Total Purchases</div>
        </div>
        <div style={S.stat}>
          <div style={{ ...S.statVal, color: "#16A34A" }}>{activeCount}</div>
          <div style={S.statLabel}>Active Now</div>
        </div>
        <div style={S.stat}>
          <div style={{ ...S.statVal, color: "#2D7DD2" }}>{fmt(totalSpent)}</div>
          <div style={S.statLabel}>Total Spent</div>
        </div>
        {totalSaved > 0 && (
          <div style={S.stat}>
            <div style={{ ...S.statVal, color: "#16A34A" }}>{fmt(totalSaved)}</div>
            <div style={S.statLabel}>Total Saved</div>
          </div>
        )}
      </div>

      {/* Purchase list */}
      {purchases.length === 0 ? (
        <div style={S.empty}>
          <div style={S.emptyIcon}>📭</div>
          <div style={S.emptyTitle}>No purchases yet</div>
          <p style={{ fontSize: 14, color: "#7A90A8", marginTop: 6 }}>
            Browse our add-on catalog to enhance your infrastructure.
          </p>
          <button style={S.emptyBtn} onClick={() => navigate?.("/addon-services")}>
            🧩 Browse Add-on Services
          </button>
        </div>
      ) : (
        <div style={S.cards}>
          {purchases.map((p) => (
            <div key={p.id} style={S.card}>
              <div style={S.cardBody}>
                <div style={S.cardLeft}>
                  <div style={S.catIcon}>{p.category_icon || "⚡"}</div>
                  <div>
                    <div style={S.svcName}>{p.service_name}</div>
                    <div style={S.svcCat}>{p.category_name}</div>
                    <span style={S.cycleChip}>{CYCLE_LABEL[p.billing_cycle] || p.billing_cycle}</span>
                  </div>
                </div>
                <div style={S.cardRight}>
                  <div style={S.price}>
                    <div style={S.priceVal}>{fmt(p.final_price)}</div>
                    {p.coupon_discount > 0 && (
                      <>
                        <div style={S.priceOrig}>{fmt(p.price_paid)}</div>
                        <div style={S.savedChip}>Saved {fmt(p.coupon_discount)}</div>
                      </>
                    )}
                  </div>
                  <span style={S.statusBadge(p.status, p.is_active)}>
                    <span style={S.statusDot(p.is_active)} />
                    {p.is_active ? "Active" : p.status === "expired" ? "Expired" : "Cancelled"}
                  </span>
                </div>
              </div>

              {/* Detail bar */}
              <div style={S.detailBar}>
                <div style={S.detailItem}>
                  <div style={S.detailLabel}>Started</div>
                  <div style={S.detailVal}>{p.starts_at}</div>
                </div>
                <div style={S.detailItem}>
                  <div style={S.detailLabel}>Expires</div>
                  <div style={{ ...S.detailVal, color: p.days_remaining < 7 && p.is_active ? "#DC2626" : "#3D5068" }}>
                    {p.expires_at}
                    {p.is_active && p.days_remaining < 30 && (
                      <span style={{ fontSize: 11, fontWeight: 800, marginLeft: 6, color: p.days_remaining < 7 ? "#DC2626" : "#D97706" }}>
                        ({p.days_remaining}d left)
                      </span>
                    )}
                  </div>
                </div>
                {p.coupon_code && (
                  <div style={S.detailItem}>
                    <div style={S.detailLabel}>Coupon Used</div>
                    <div style={{ ...S.detailVal, color: "#16A34A", fontFamily: "'Courier New',monospace", fontSize: 12 }}>
                      {p.coupon_code}
                    </div>
                  </div>
                )}
                <div style={S.detailItem}>
                  <div style={S.detailLabel}>Purchase #</div>
                  <div style={{ ...S.detailVal, fontFamily: "'Courier New',monospace", fontSize: 12, color: "#7A90A8" }}>
                    #{p.id}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyAddonsPage;